export const banners = [
  {
    movieId: 'mv-01',
    image:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20lone%20spacecraft%20drifting%20toward%20a%20vast%20glowing%20nebula%20in%20deep%20blue%20space%20with%20warm%20amber%20light%20trails%20atmospheric%20film%20still%20dramatic%20lighting%20high%20detail&width=1600&height=900&seq=hema-bn-01&orientation=landscape',
  },
  {
    movieId: 'mv-02',
    image:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20wide%20shot%20of%20a%20foggy%20harbour%20city%20skyline%20at%20night%20with%20glowing%20streetlights%20reflected%20on%20wet%20pavement%20deep%20blue%20tones%20with%20warm%20amber%20highlights%20atmospheric%20film%20still%20high%20detail&width=1600&height=900&seq=hema-bn-02&orientation=landscape',
  },
  {
    movieId: 'mv-03',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20lone%20figure%20walking%20along%20an%20empty%20winter%20road%20at%20dawn%20with%20soft%20mist%20deep%20blue%20tones%20and%20warm%20amber%20sunrise%20light%20atmospheric%20film%20still%20high%20detail&width=1600&height=900&seq=hema-bn-03&orientation=landscape',
  },
  {
    movieId: 'tv-01',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20ancient%20chinese%20lantern%20lit%20streets%20at%20dusk%20with%20warm%20glowing%20lights%20and%20deep%20blue%20evening%20sky%20atmospheric%20film%20still%20dramatic%20lighting%20high%20detail&width=1600&height=900&seq=hema-bn-04&orientation=landscape',
  },
];